/* eslint-disable @typescript-eslint/no-explicit-any */
import { Localization } from '../../localization/localization';

let warningContainer: JQuery;
const cookiesGroups: {
    [group: string]: {
        companies?: string[]
    }
} = {
    Strictly_Necessary: {},
    Statistics: {
        companies: ['Yandex', 'Google', 'Facebook', 'Mail', 'VK']
    }
};


function okClickHandler() {
    saveCookiesConfig(true);
}

function moreClickHandler() {
    showCookieConfigWindow();
}


export function initCookieWarning() {
    warningContainer = $('#cookie-warning-js');
    if (!warningContainer.length) {
        return;
    }

    const okButton = warningContainer.find('.cookie-warning__buttons .btn__accept');
    const moreButton = warningContainer.find('.cookie-warning__buttons .button__config');

    okButton.on('click', okClickHandler);
    moreButton.on('click', moreClickHandler);

    const warnText = warningContainer.find('.cookie-warning__text');
    const linkOpt = 'class="js-click popup_link1" data-id="privacy_policy"' +
        ' data-hideclass="document_popup" data-handler="popup"';
    const text = Localization._n(`cookie.warning_text`);
    warnText.html(Localization.addLinkToText(text, `//${window.app.config.domain}/#privacy_policy`, linkOpt));

    if ($.cookie('cookieConfig') !== undefined) {
        warningContainer.remove();
    } else {
        warningContainer.show();
    }
}

function showCookieConfigWindow() {
    let cookieOptionsDiv = document.createElement('div');
    cookieOptionsDiv.setAttribute('class', 'cookie-warning__options');
    const closeOptionsDiv = document.createElement('div');
    closeOptionsDiv.setAttribute('class', 'close__button');
    closeOptionsDiv.addEventListener('click', ()=>{ cookieOptionsDiv.remove(); });
    cookieOptionsDiv.appendChild(closeOptionsDiv);

    cookieOptionsDiv = addGroupBlocks(cookieOptionsDiv);

    const body = document.querySelector('body');
    body.appendChild(cookieOptionsDiv);
}

function addGroupBlocks(cookieOptionsDiv:HTMLDivElement) {
    const cookieBlocks:any = {};
    cookieOptionsDiv.appendChild(setTitleBlock(cookieBlocks));

    for (const key in cookiesGroups) {
        const group = key;
        const groupName = group.toLowerCase().replace(' ', '_');

        const groupItem:any = cookiesGroups[key];
        let groupBlock = cookieBlocks[groupName];
        groupBlock = document.createElement('div');
        groupBlock.setAttribute('class', `cookie__group ${groupName}`);


        if (groupName.includes('necessary')) {
            const groupBlockName = document.createElement('p');
            groupBlockName.textContent = Localization._n(`cookies.groups.names.${groupName}`);
            groupBlockName.setAttribute('class', 'name');

            const alwaysActive = document.createElement('span');
            alwaysActive.textContent = Localization._n(`cookies.groups.buttons.active`);
            groupBlockName.appendChild(alwaysActive);

            groupBlock.appendChild(groupBlockName);
        }


        if (groupItem.companies) {
            const switchText = Localization._n(`cookies.groups.names.${groupName}`);
            const switchGroup = getSwitchBox(groupName, switchText, (event: any) => {
                const group = document.querySelectorAll(`.cookie__group.${groupName} .cookie__checkbox`);
                const checked = event.target.checked;
                group.forEach((element: HTMLInputElement)=>{
                    if (element.id !== groupName) { element.checked = checked; }
                });
            });
            groupBlock.appendChild(switchGroup);
        }

        const groupBlockText = document.createElement('p');
        groupBlockText.textContent = Localization._n(`cookies.groups.text.${groupName}`);
        groupBlockText.setAttribute('class', 'text__content');
        groupBlock.appendChild(groupBlockText);


        if (groupItem.companies) {
            groupBlock = addCompanies(groupBlock, groupItem);
        }


        cookieOptionsDiv.appendChild(groupBlock);
    }

    const acceptBtn = document.createElement('btn');
    acceptBtn.setAttribute('class', 'btn__accept button');
    acceptBtn.textContent = Localization._n(`cookies.groups.buttons.accept`).toUpperCase();
    acceptBtn.addEventListener('click', () => {
        saveCookiesConfig();
        cookieOptionsDiv.remove();
    });

    cookieOptionsDiv.appendChild(acceptBtn);

    return cookieOptionsDiv;
}

function getSwitchBox(name: string = '', text: string = '', callback?:(event: any)=>void) {
    const switchBlock = document.createElement('div');
    switchBlock.setAttribute('class', 'switch__box');

    const checkBox = document.createElement('input');
    checkBox.setAttribute('type', 'checkbox');
    checkBox.setAttribute('class', 'cookie__checkbox');
    checkBox.setAttribute('id', `${name}`);
    checkBox.setAttribute('name', `${name}`);
    checkBox.setAttribute('checked', 'checked');
    if (callback) {
        checkBox.addEventListener('click', callback);
    }
    const label = document.createElement('label');
    label.setAttribute('for', `${name}`);


    const switchBody = document.createElement('span');
    const switchElement = document.createElement('i');
    switchBody.appendChild(switchElement);

    if (text) {
        const boxText = document.createElement('p');
        boxText.textContent = text;
        label.appendChild(boxText);
    }

    label.appendChild(switchBody);
    switchBlock.appendChild(checkBox);
    switchBlock.appendChild(label);


    return switchBlock;
}

function addCompanies(groupBlock:HTMLDivElement, item:any):HTMLDivElement {
    const companiesBlock = document.createElement('div');
    companiesBlock.setAttribute('class', 'companies');
    for (const index in item.companies) {
        const company = item.companies[index];

        const companyBlock = document.createElement('div');
        companyBlock.setAttribute('class', `company_name`);
        companyBlock.setAttribute('id', company);
        companyBlock.style.display = 'block';


        const switchBox = getSwitchBox(`${company.toLowerCase()}`, company);
        companyBlock.appendChild(switchBox);
        companiesBlock.appendChild(companyBlock);
    }

    const showBox = document.createElement('div');
    showBox.setAttribute('class', 'show__box');

    const showBoxText = document.createElement('p');
    showBoxText.setAttribute('class', 'show__box-text');
    showBoxText.textContent = Localization._n(`cookies.groups.names.show_text`);

    showBoxText.addEventListener('click', ()=>{
        showBoxText.remove();
        showBox.setAttribute('class', 'show__box show');
    });

    showBox.appendChild(showBoxText);
    showBox.appendChild(companiesBlock);
    groupBlock.appendChild(showBox);

    return groupBlock;
}

function setTitleBlock(cookieBlocks:any) {
    cookieBlocks.title = document.createElement('div');
    cookieBlocks.title.setAttribute('class', 'cookie__group title');

    const groupBlockName = document.createElement('p');
    groupBlockName.textContent = Localization._n(`cookies.groups.names.title`);
    groupBlockName.setAttribute('class', 'name');
    cookieBlocks.title.appendChild(groupBlockName);

    const line = document.createElement('div');
    line.setAttribute('class', 'line');
    cookieBlocks.title.appendChild(line);

    const groupBlockText = document.createElement('p');
    const linkOpt = `class="js-click popup_link1" data-id="privacy_policy" data-hideclass="document_popup" data-handler="popup"`;
    groupBlockText.innerHTML = Localization.addLinkToText(Localization._n(`cookie.warning_text`), `//${window.app.config.domain}/#privacy_policy`, linkOpt);

    groupBlockText.setAttribute('class', 'text__content');
    cookieBlocks.title.appendChild(groupBlockText);

    return cookieBlocks.title;
}

function collectConfig() {
    const checkBoxes = document.querySelectorAll('.cookie__group > .switch__box .cookie__checkbox');

    const configObject:any = {};
    clearAllCookies();
    checkBoxes.forEach((checkBox: HTMLInputElement)=>{
        configObject[checkBox.id] = {};
        configObject[checkBox.id].isOn = checkBox.checked;
    });


    for (const index in configObject) {
        const companiesSelected = document.querySelectorAll(`.cookie__group.${index}  .companies .cookie__checkbox`);
        configObject[index].companies = {};
        companiesSelected.forEach((checkBox: HTMLInputElement)=>{
            configObject[index].companies[checkBox.id.toLowerCase()] = checkBox.checked;
            if (!configObject[index].isOn) { configObject[index].companies[checkBox.id.toLowerCase()] = false; }
        });
    }

    return configObject;
}

function clearAllCookies() {
    const cookies = document.cookie.split('; ');
    for (const index in cookies) {
        const host = window.location.hostname.split('.');
        while (host.length > 0) {
            const cookieBase = `${encodeURIComponent(cookies[index].split(';')[0].split('=')[0])}=; expires=Thu, 01-Jan-1970 00:00:01 GMT; domain=${host.join('.')} ;path=`;
            const path = location.pathname.split('/');
            document.cookie = `${cookieBase}/`;
            while (path.length > 0) {
                document.cookie = cookieBase + path.join('/');
                path.pop();
            }
            host.shift();
        }
    }
}

function saveCookiesConfig(acceptAll = false) {
    let config:any = {};
    if (!acceptAll) {
        config = collectConfig();
    } else {
        for (const key in cookiesGroups) {
            const groupItem:any = cookiesGroups[key];
            const group = key;
            const groupName = group.toLowerCase().replace(' ', '_');
            config[groupName] = {};
            if (!groupName.includes('necessary')) {
                config[groupName] = {};
                config[groupName].isOn = true;
            }


            config[groupName].companies = {};
            for (const index in groupItem.companies) {
                config[groupName].companies[groupItem.companies[index].toLowerCase()] = true;
            }
        }
    }
    $.cookie('cookieConfig', JSON.stringify(config), {
        expires: 365,
        path: '/',
        domain: `.${window.app.config.domain}`,
        secure: true
    });
    warningContainer.remove();
}

